import { SyncOutlined } from '@ant-design/icons'

export const GAMEPLAY_STATUSES = [
  { name: "Created", value: "created" },
  { name: "Invited", value: "invited" },
  { name: "Playing", value: "playing" },
  { name: "Completed", value: "completed" },
  { name: "Cancelled", value: "cancelled" },
  // { name: "Clear", value: "" },
];

export const HIRING_STATUSES = [
  {
    name: "Shortlisted",
    value: "shortlisted-sub",
    children: [
      { name: "Initial Stage", value: "shortlisted" },
      { name: "Offer Rolled Out", value: "offer-rolled-out" },
      { name: "Hired", value: "hired" },
    ]
  },
  {
    name: "Rejected",
    value: "rejected-sub",
    children: [
      { name: "Initial Stage", value: "rejected" },
      { name: "Post Shortlist", value: "shortlisted-reject" },
      { name: "Post Offer", value: "offer-rolled-out-reject" },
    ]
  },
  {
    name: "Dropped Out",
    value: "dropout",
    children: [
      { name: "Post Shortlist", value: "shortlisted-dropout" },
      { name: "Post Offer", value: "offer-rolled-out-dropout" },
    ]
  },
];

export const USER_STATUSES = [
  { name: "Disqualified", value: 1 },
  { name: "Qualified", value: 0 },
  { name: "Expired", value: 20 },
];

export const TRUST_SCORES = [
  { name: "75 - 100", value: "75-100" },
  { name: "50 - 75", value: "50-74.9" },
  { name: "25 - 50", value: "25-44.9" },
  { name: "0 - 25", value: "0-24.9" },
]

export const CUTOFF_VALUES = [
  { name: "Cleared", value: "true" },
  { name: "Not Cleared", value: "false" },
]

export const REPORT_OPTIONS = [
  { name: "Pending", value: "pending" },
  { name: "Generated", value: "generated" },
  { name: "Clear", value: "" },
  // { name: "Shortlisted", value: "shortlist" },
];

export const SORT_OPTIONS = [
  { name: "Recently changed", value: "-updatedAt" },
  { name: "Highest fitscore", value: "-fitScore" },
  {
    name: <div className="flex items-center">
      <SyncOutlined />
      <span className="ml-4 mb--2">Clear All</span>
    </div>,
    value: "clear"
  }
];

export const GAMEPLAY_KEY = 'gameplay';
export const HIRING_KEY = 'hiring';
export const USER_STATUS_KEY = 'user_status';
export const FIT_SCORE_KEY = "fitScoreRange"
export const TRUST_SCORE_KEY = "trustScoreRange"
export const CUTOFF_KEY = "cutOffCleared"
export const CLEAR_KEY = 'clear';

export const INITIAL_VALUES = {
  gameplayStatus: "",
  hiringStatus: "",
  reportStatus: "",
  linkStatus: "",
  fitScoreRange: "",
  trustScoreRange: "",
  created: "",
  sort: "",
};